import ReservationCard from 'components/HappeningNonContent/Reservations/ReservationCard/ReservationCard';

export default ReservationCard;
